// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/hero.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
.login-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 360px;
  
}

.card-login {
  border-radius: 50px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
  height: 350px;
}

.login-card-body {
  background-color: rgba(162, 200, 238, 0.5);
  padding: 30px;
  border-radius: 50px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
  height: 350px;
}

.login-box-msg {
  margin-bottom: 30px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(50, 151, 218, 0.897);
}

.input-group-text {
  background-color: rgba(141, 158, 176, 0.8);
  border: none;
  color: #fff;
  border-radius: 10px;
}

.input-group-text .fas {
  color: #3b3b3b;
}

.btn-login {
  background-color: #497eb5 ;
  border: none;
  margin-top: 50px;
  border-radius: 10px;
  color: #fff;
  height: 38px;
}

.btn-login:hover {
  background-color: #6193c9;
  color: #fff;
}

.message-msg {
  color: #a5f5fa;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/component/login/Login.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* App.css */\r\n.login-page {\r\n  background-image: url(\"../images/hero.png\");\r\n  background-size: cover;\r\n  background-position: center;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.login-box {\r\n  width: 360px;\r\n  \r\n}\r\n\r\n.card-login {\r\n  border-radius: 50px;\r\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);\r\n  height: 350px;\r\n}\r\n\r\n.login-card-body {\r\n  background-color: rgba(162, 200, 238, 0.5);\r\n  padding: 30px;\r\n  border-radius: 50px;\r\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);\r\n  height: 350px;\r\n}\r\n\r\n.login-box-msg {\r\n  margin-bottom: 30px;\r\n  text-align: center;\r\n  font-size: 24px;\r\n  color: #fff;\r\n  text-shadow: 2px 2px 4px rgba(50, 151, 218, 0.897);\r\n}\r\n\r\n.input-group-text {\r\n  background-color: rgba(141, 158, 176, 0.8);\r\n  border: none;\r\n  color: #fff;\r\n  border-radius: 10px;\r\n}\r\n\r\n.input-group-text .fas {\r\n  color: #3b3b3b;\r\n}\r\n\r\n.btn-login {\r\n  background-color: #497eb5 ;\r\n  border: none;\r\n  margin-top: 50px;\r\n  border-radius: 10px;\r\n  color: #fff;\r\n  height: 38px;\r\n}\r\n\r\n.btn-login:hover {\r\n  background-color: #6193c9;\r\n  color: #fff;\r\n}\r\n\r\n.message-msg {\r\n  color: #a5f5fa;\r\n  font-size: 15px;\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
